import React, {useEffect, useState} from 'react';
import entityService from "../../../../Service/EntityService";
import EntityCard from "./EntityCard";
import LevelForm from "./Forms/LevelForm";
import Loader from "../../../Static/Loader/Loader";
import TaskForm from "./Forms/TaskForm";
import s from './entity-constructor.module.css'

const EntityConstructor = ({setEntity, setIsLoad, setErrorMessage, entityName, entities, tasks, additionalTasks}) => {
    const [activeEntity, setActiveEntity] = useState(null)
    useEffect(() => {
        setActiveEntity(null)
    }, [entities])
    console.log('Entities', entities)
    const deleteEntity = async(entityId)=>{
        try{
            await entityService.delete(entityName, entityId)
            return true
        } catch (e) {
            console.log(e)
            return false
        }
    }

    const addEmptyEntityFunc = entityService.getEmptyEntityFunc(entityName)
    
    const saveEntity = async ()=>{
        setIsLoad(false)
        const isCreateNew = !activeEntity.id
        const executeFunc = isCreateNew? entityService.add : entityService.update
        try {
            const entityResult = await executeFunc(entityName, activeEntity)
            console.log("entityResult", entityResult)
            const newEntityArr = isCreateNew? [...entities, entityResult]
                :  entities.map(e => {
                if(e.id === activeEntity.id){
                    return entityResult
                }
                return e
            })

            setActiveEntity(null)
            console.log('newEntityArr', newEntityArr)
            setEntity([...newEntityArr])
        } catch (e) {
            console.log(e)
            setErrorMessage(e)
        } finally{
            setIsLoad(true)
        }
    }
    if (!entities){
        return <Loader />
    }
    return (
        <>
            {!activeEntity?
                <div>
                    {entities.map((entity)=>{
                        return <div key={entity.id}>
                            <EntityCard entity={entity} deleteEntity={deleteEntity} updatedEntity={()=>setActiveEntity(entity)} />
                        </div>
                    })}
                    <div onClick={()=>{
                        setActiveEntity(addEmptyEntityFunc())
                    }} className={'btn'}>Добавить</div>
                </div>:
                <div>
                    {entityName === "level" &&
                        <LevelForm additionalTasks={additionalTasks} changeData={entity=>setActiveEntity(entity)} entity={activeEntity} tasks={tasks}/>
                    }
                    {(entityName === "additional_task" || entityName === "task") &&
                        <TaskForm changeData={entity=>setActiveEntity(entity)} entity={activeEntity}/>
                    }
                    <div onClick={async(e)=>{
                        setIsLoad(false)
                        e.target.innerText = 'Сохраняю...'
                        await saveEntity()
                        setTimeout(()=>{
                            e.target.innerText = 'Сохранить'
                            setIsLoad(true)
                        },1200)
                    }} className={'btn'}>Сохранить</div>
                    <div onClick={()=>{
                        setActiveEntity(null)
                    }} className={'btn'}>Закрыть</div>
                </div>
            }

        </>
    )
};

export default EntityConstructor;